/* eslint-disable prettier/prettier */

const buttonSpace = () => {
  // Find all buttons with the `.wmnds-btn` class
  const buttons = document.querySelectorAll('.wmnds-btn');
  buttons.forEach((btn) => {
    // Use previousElementSibling to find the element immediately before the button
    const prev = btn.previousElementSibling;

    // Determine the actual <p> element that should be adjusted.
    // Handle cases where the <p> is the previous sibling, or where the previous sibling
    // is a <div> that contains the <p> (e.g. <div><p>...</p></div><button>...)
    let targetP = null;

    if (prev && prev.tagName) {
      const name = prev.tagName.toLowerCase();
      if (name === 'p') {
        targetP = prev;
      } else if (name === 'div') {
        const lastChild = prev.lastElementChild;
        if (lastChild && lastChild.tagName && lastChild.tagName.toLowerCase() === 'p') {
          targetP = lastChild;
        } else {
          // fallback: find any <p> inside the div
          const anyP = prev.querySelector('p');
          if (anyP) targetP = anyP;
        }
      }
    }

    if (targetP) {
      // Only apply if the paragraph is within a <div> ancestor
      if (targetP.closest && targetP.closest('div')) {
        targetP.style.marginBottom = '0px';
      }
    }
  });
};

export default buttonSpace;
